// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3fkGz","item":"PaymentsMobile_item__2RXMt","label":"PaymentsMobile_label__1ZceP","amount":"PaymentsMobile_amount__2579Y"};